var exports = {
  "R": "radioGroup__MnISXF",
  "P": "checkboxGroup__tLcual",
};

module.exports = exports;
